<template>
    <carousel v-if="slides.length"
        v-drag-notifier="setIsDragged"
        :autoplay="true"
        :autoplayTimeout="8000"
        :loop="true"
        :perPage="1"
        paginationActiveColor="#8EC641"
        paginationPosition="bottom-overlay"
    >
        <slide v-for="(slide, index) of slides"
            :key="index"
            class="slide"
        >
            <div :class="['slide__content', {'slide__content--clickable': slide.link.url}]"
                @click="redirect(slide.link)"
            >
                <div v-if="slide.headings.primary.text"
                    :style="{ color: slide.headings.primary.color }"
                    :class="['heading', 'heading--primary', { 'heading--right-aligned': slide.headings.isRightAligned }]"
                >
                    {{ slide.headings.primary.text }}
                </div>

                <div v-if="slide.headings.secondary.text"
                    :style="{ color: slide.headings.secondary.color }"
                    :class="['heading', 'heading--secondary', { 'heading--right-aligned': slide.headings.isRightAligned }]"
                >
                    {{ slide.headings.secondary.text }}
                </div>

                <router-link v-if="slide.button.text"
                    :to="{ path: slide.link.url, params: slide.link.props }"
                    :class="['button', { 'button--right-aligned': slide.headings.isRightAligned }]"
                    :style="{ color: slide.button.color, backgroundColor: slide.button.background }"
                >
                    {{ slide.button.text }}
                </router-link>
            </div>

            <img :src="slide.imageUrl"
                alt=""
                class="slide__image"
            >

            <loading-spinner />
        </slide>
    </carousel>
</template>

<script>
// Components
import loadingSpinner from '@webapp/components/loading-spinner/loading-spinner.vue';
import {
    Carousel,
    Slide,
} from 'vue-carousel';

// Config
import {
    LinkState,
} from '@webapp/config/banners';

export default {
    name: 'slides',
    components: {
        loadingSpinner,
        Carousel,
        Slide,
    },
    props: {
        slides: {
            type: Array,
            default: () => ([]),
        },
    },
    data() {
        return {
            isDragged: false,
        };
    },
    methods: {
        setIsDragged(isDragged) {
            this.isDragged = isDragged;
        },

        redirect({
            url,
            props,
            isExternal,
            name,
        }) {
            if (!this.isDragged && url) {
                if (isExternal) {
                    window.open(url, '_blank');

                    return;
                }

                if (url === LinkState.Unavailable) {
                    // ToDo - Redirect to Download our mobile page or show modal
                    console.error('Page not available');
                } else {
                    this.$router.push({
                        name,
                        path: url,
                        params: props,
                    });
                }
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.slide {
    height: 20rem;
    position: relative;

    @include min-width(md) {
        height: 48rem;
    }

    &__content {
        display: flex;
        position: absolute;
        width: 100%;
        height: 100%;
        flex-direction: column;
        color: $white-color;
        justify-content: center;
        z-index: 3;

        &--clickable {
            cursor: pointer;
        }

        .heading {
            line-height: 1;

            &--right-aligned {
                align-self: flex-end;
            }

            &--primary,
            &--secondary {
                max-width: 50%;
                padding-left: 2rem;

                @include min-width(md) {
                    padding-left: 5rem;
                }
            }

            &--primary {
                font-size: clamp(1.6rem, 3vw, 7rem);
                font-family: "Monument", sans-serif;
            }

            &--secondary {
                font-size: clamp(1rem, 3vw, 3rem);
                margin-top: 3rem;
                margin-bottom: 2rem;
                font-family: "Galano Grotesque SemiBold";
            }
        }

        .button {
            font-size: 1.5rem;
            color: $white-color;
            border: 0.2rem solid;
            text-decoration: none;
            padding: 0 1rem;
            border-radius: 5rem;
            align-self: flex-start;
            margin: 0 5rem;
            font-family: "Galano Grotesque Medium";

            @include min-width(lg) {
                font-size: 1.5rem;
                padding: 1rem 1.5rem;
            }

            &--right-aligned {
                align-self: flex-end;
            }

            &:hover {
                opacity: 0.8;
            }
        }
    }

    &__image {
        position: relative;
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: left;
        z-index: 2;
    }

    .spinner {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        z-index: 1;
    }
}
</style>